
<style>
  .Special{
    background-color:#ff9595 !important;
  }

</style>

<div class="col-md-12 mb-30" *ngIf="Data_View_Customer.id==0">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">نظرات </h5>
     <br/>

     <div class="row">

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">نام مشتری  </label>
        <input [(ngModel)]="Name" type="text" class="form-control"  placeholder="برای جستجوی اینجا تایپ کنید ...">

      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">زمینه فعالیت</label>
        <select class="custom-select" [(ngModel)]="FeildActivityId">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_FeildActivity" [value]="item.id">{{item.title}}</option>
        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">استان </label>
        <select class="custom-select" [(ngModel)]="ProvinceId"  (change)="ProvinceChange()">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">شهرستان</label>
        <select class="custom-select" [(ngModel)]="CityId" >
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1"> نوع مشتریان </label>
        <select class="custom-select" [(ngModel)]="SearchCommentType">
          <option value="0">همه مشتریان</option>
          <option value="1">مشتریان بدون نظر</option>
          <option value="2">مشتریان با نظر</option>
        </select>
      </div>

    </div>

     <div class="row">
      <div  class="form-group col-md-12" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Customer()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام مشتری</th>
              <th>کد مشتری</th>
              <th>ایجاد کننده</th>
              <th>تاریخ ایجاد</th>
              <th>ویرایش کننده</th>
              <th>تاریخ ویرایش</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>

              <td>{{item.code}}</td>

              <td>{{item.create_user}} </td>
              <td>{{item.create_date}} </td>
              <td>{{item.update_user}} </td>
              <td>{{item.update_date}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" class="dropdown-item" (click)="OpenNoteDialog(templateComment,item)"><i class="fa fa-pencil"></i> ثبت نظر جدید </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Customer_view(item)"><i class="fa fa-file"></i> مشاهده نظرات </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Customer"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<app-CutomerCommentView
  *ngIf="Data_View_Customer.id>0"
  (OnBack_Comment_Action)="OnBack_Comment_Action_Rest($event)"
  [Customer_Inner]="Data_View_Customer">

</app-CutomerCommentView>


<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> ثبت نظر جدید برای مشتری '{{Data_Seleted_Customer.name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Note.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">شرح</label>
        <textarea type="text" class="form-control" [(ngModel)]="Note_Dsc" placeholder="اینجا تایپ کنید ...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="SubmitNote()">
      ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Note.hide()">بستن</button>
  </div>
</ng-template>
